import { Link } from 'react-router-dom';

function HomeFounderSection() {
  return (
    <section className="band bg-white" id="about" aria-labelledby="founder-title">
      <div className="wrap founder">
        <div className="founder-photo ph">
          <img className="founder-photo-img" src="/images/chai.png" alt="Chaitanya Allidona" />
        </div>
        <div>
          <div className="kicker">Your Mentor to Lead With Tech</div>
          <h2 id="founder-title">Chaitanya Allidona</h2>
          <div className="role">Founder, Lead With Tech - AI Productivity Trainer</div>
          <p>I spent years in software - first as a developer, then an architect, then a leader. The same gap kept showing up: technically strong engineers who couldn't make the jump to the next level because nobody had ever taught them how to think beyond the code.</p>
          <p><strong>Lead With Tech exists to close that gap.</strong> Every program here is built from the real decisions I had to learn the hard way - how to design at scale, how to work with AI without losing engineering discipline, and how to build a career with intention rather than just hoping the next promotion comes.</p>
          <p>I show up to every session personally - no pre-recorded content, no outsourced instruction. Just the frameworks, the feedback, and the mentorship I wish I&#39;d had earlier in my own career.</p>
          {/* <Link className="btn btn-red" to="/about" style={{ marginTop: '26px' }}>Read My Story</Link> */}
        </div>
      </div>
    </section>
  );
}

export default HomeFounderSection;
